<template>
    <section class="container">
        <h2>GUÍA DE CENTROS DE SALUD</h2>
        <div class="card-header text-center py-3">
            <h3 class="card-title fuente-color-gobierno margin-subtitulo"><i
                    class="far fa-hospital fuente-color-gobierno"></i> Instituciones</h3>
        </div>
        <div class="card-body">
            <div class="row justify-content-center pb-5">
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Hospital Dr. Guillermo Rawson</strong>
                            </h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Director Ejecutivo:</strong> Dr. Juan Pablo Gempel</p>
                            <p class="card-text"><strong>Director Médico de Planificación y Gestión
                                    Asistencial:</strong> Dr. Adrián Horacio D’ovidio</p>
                            <p class="card-text"><strong>Director Administrativo:</strong> CPN Daniel Héctor Ferrero</p>
                            <p class="card-text"><strong>Domicilio:</strong> Av.Rawson 494 sur, San Juan</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 422-4005</p>
                        </div>
                        <div class="card-footer">
                            <div class="row justify-content-md-center">
                                <a href="http://hospitalrawson.sanjuan.gov.ar/" class="btn btn-secondary text-center"
                                    target="_blank">Sitio Web</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Hospital Dr. Marcial Quiroga</strong>
                            </h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Director Ejecutivo:</strong> Dr. Juan Manuel Campayo 
                            </p>
                            <p class="card-text"><strong>Director Médico:</strong> Dr. Sergio Gabriel Albarracín</p>
                            <p class="card-text"><strong>Director Administrativo:</strong> CPN Carlos Sebastián Godoy
                            </p>
                            <p class="card-text"><strong>Domicilio:</strong> Av. Libertador 5401 oeste, Rivadavia, San
                                Juan</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 433-0880 o 433-0970</p>
                        </div>
                        <div class="card-footer">
                            <div class="row justify-content-md-center">
                                <a href="https://hospitalmarcialquiroga.sanjuan.gob.ar/"
                                    class="btn btn-secondary text-center" target="_blank">Sitio Web</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Hospital General Dra. Julieta
                                    Lanteri</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Director:</strong> Dr. Carlos Stolzing</p>
                            <p class="card-text"><strong>Domicilio:</strong> Av. José Ignacio de la Roza 8000 Oeste, La
                                Bebida, Rivadavia, San Juan</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 421-2442</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row margin-row justify-content-center pb-5">
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Dirección de Obra Social
                                    Provincia</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Interventor:</strong>Dr. Rodolfo Daniel Fasoli</p>
                            <p class="card-text"><strong>Domicilio:</strong> Agustín Gnecco 360 (S), San Juan</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 422-5515 o 422-3618</p>
                        </div>
                        <div class="card-footer">
                            <div class="row justify-content-md-center">
                                <a href="http://www.obrasocial.sanjuan.gob.ar/dos/"
                                    class="btn btn-secondary text-center" target="_blank">Sitio Web</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Instituto Provincial de Hemoterapia
                                    IPHEM</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Coordinador:</strong> Dra. Rosario Rocca</p>
                            <p class="card-text"><strong>Domicilio:</strong> Calle Rivadavia 728 este</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 422-3571</p>
                            <p class="card-text"><strong>Contacto:</strong> iphem.sanjuan@gmail.com</p>
                            <p class="card-text"><strong>Horarios:</strong> 7 a 13 hs.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Instituto de Ablación e Implantes de
                                    San Juan INAISA</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Coordinador:</strong> Dra. Marcela Rosana Gelvez</p>
                            <p class="card-text"><strong>Domicilio:</strong> INAISA-INCUCAI San Juan, Edificio Histórico
                                1º piso, Htal Dr. Guillermo Rawson</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 420-1029</p>
                            <p class="card-text"><strong>Contacto:</strong> inaisasanjuan@yahoo.com.ar - Facebook:
                                inaisa san juan</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row margin-row justify-content-center">
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Instituto Odontológico “Dr. Cayetano
                                    Torcivia”</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Coordinador:</strong> Dr. Gustavo Quiroga</p>
                            <p class="card-text"><strong>Domicilio:</strong> Rivadavia 686 Este, San Juan</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 427-7586</p>
                            <p class="card-text"><strong>Contacto:</strong> institutoodontologico11@hotmail.com</p>
                            <p class="card-text"><strong>Horarios:</strong> Lun a Vie de 7:30 a 11:30 hs. - Tarde: 13:00
                                a 17:30 hs. - Sábados: guardia de 8:00 a 12:00 hs.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Centro por la Vida</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Coordinador:</strong> Dr. Andrés Manini</p>
                            <p class="card-text"><strong>Domicilio:</strong> Calle Mendoza 346 norte, San Juan</p>
                            <p class="card-text"><strong>Teléfono:</strong> 4202791 </p>
                            <p class="card-text"><strong>Contacto:</strong> centroxvida@gmail.com</p>
                            <p class="card-text"><strong>Horarios:</strong> Lunes a Viernes de 7 a 17 hs.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Centro Terapeutico Aurora
                                    Perez</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Coordinadoras:</strong> Lic. María José Pringles Frías - Lic.
                                María Eugenia Girado</p>
                            <p class="card-text"><strong>Domicilio:</strong> Av. Leandro N. Alem 157 –S- San Juan</p>
                            <p class="card-text"><strong>Teléfono:</strong> 4273842 </p>
                            <p class="card-text"><strong>Contacto:</strong> centro.terapeutico@sanjuan.gov.ar</p>
                            <p class="card-text"><strong>Horarios:</strong> Lunes a Viernes de 7:30 a 15:30 hs.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-header text-center py-3">
            <h3 class="card-title fuente-color-gobierno margin-subtitulo"><i
                    class="far fa-hospital fuente-color-gobierno"></i> Zonas Sanitarias</h3>
        </div>
        <div class="card-body">
            <div class="row justify-content-center pb-5">
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Zona Sanitaria I</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Jefe:</strong> Dra. Nancy Elizabeth Morales Poblete</p>
                            <p class="card-text"><strong>Domicilio:</strong> Calle Matías Zavalla y San Lorenzo - Bº del
                                Carmen, Capital. Centro de Salud. Dr. Alfonso Barassi</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 426-6463</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Zona Sanitaria II</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Jefe:</strong> Dr. José Antonio Bernal</p>
                            <p class="card-text"><strong>Domicilio:</strong> Diagonal Sarmiento 367</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 4963424</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Zona Sanitaria III</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Jefe:</strong> Dra. Ivonne Hortensia García</p>
                            <p class="card-text"><strong>Domicilio:</strong> Barrio Albardón I Casa 1, Albardón</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 491-2181</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row margin-row justify-content-center pb-5">
                <div class="col-md-3 pb-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Zona Sanitaria IV</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Jefe:</strong> Dr. Daniel Enrique Gualpa</p>
                            <p class="card-text"><strong>Domicilio:</strong> Calle Coll - Bº Huaziul - (O)Rivadavia</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 423-3912</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 pb-3 cont">
                    <div class="card h-100">
                        <div class="card-header text-center titleCard">
                            <h5 class="card-title fuente-color-gobierno"><strong>Zona Sanitaria V</strong></h5>
                        </div>
                        <div class="card-body">
                            <p class="card-text"><strong>Jefe:</strong> Dra. Patricia Mut</p>
                            <p class="card-text"><strong>Domicilio:</strong> Fermín Rodriguez y Tierra del Fuego (CARF).
                                Rawson</p>
                            <p class="card-text"><strong>Teléfono:</strong> (264) 424-0379</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.titleCard {
    background-color: #FF8200;
    color: #fff;
    height: 120px;
}

.cont {
    margin-bottom: 15px;
}

@media (max-width: 767px) {
    .cont {
        margin-bottom: 30px;
    }
}
</style>